
import API from '../config/api.js'

export const SupplierService = {    
  
    getSupplierList(search='', page=1) {
        return API.get('/api/supplier', {
            params: {
                search: search,
                page: page,
            },
        });
    },    

    getSupplierInfo(uuid) {
        return API.get(`api/supplier/${uuid}/info`);
    },

    dropSupplier(id) {
        return API.delete(`api/supplier/delete/${id}`);
    },

    getCountries(){
        return API.get(`api/suppliers/countries`);
    },

    getStates(country){
        return API.get(`api/suppliers/states/${country}`);
    },
    getSupplierCatergories(){
        return API.get(`api/supplier/suppliercatergory`);
    },

    async updateSupplier(id, formData) {
        console.log("Form data submitted to API for update:", formData);
        try {
            formData.append("id", id);
            const response = await API.post(`/api/supplier/update`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            return response.data;
        } catch (error) {
            console.error("Error updating Supplier:", error);
            throw error;
        }
    },    


    createSupplier(formData) {
        console.log("Form data submitted to api",formData);
        return API.post("/api/supplier/create", formData, {
            headers : {
                'Content-Type': 'multipart/form-data'
            }
          }); 
        },

    async fetchSupplierDetails(id) {
        const response = await API.get(`/api/supplier/fetchSupplierDetails/${id}`);
        return response.data;
      },

    async createCategory(data) {
        try {
            return API.post('/api/supplier/createCategory', data);
        } catch (error) {
            console.error("Error creating supplier category:", error);
            throw error;
        
        }
    },

    getPurchaseOrders(uuid) {
        return API.get(`/api/supplier/${uuid}/purchase-orders`);
    },

    getGoodsReceived(uuid) {
        return API.get(`/api/supplier/${uuid}/goods-received`);
    },

    getPaymentVouchers(uuid) {
        return API.get(`/api/supplier/${uuid}/payment-vouchers`);
    },

    getGoodsReturns(uuid) {
        return API.get(`/api/supplier/${uuid}/goods-returns`);
    },

    getAccountSummary(uuid) {
        return API.get(`/api/supplier/${uuid}/account-summary`);
    }

}